import React, { CSSProperties } from "react";
import LabeledTextInput from "../../../../ui-components/molecules/labeled-inputs/labeled-text-input/labeledTextInput";
import { LabelModes } from "../../../../ui-components/molecules/labeled-inputs/labeledInput";
import XGSSelect from "../../../../ui-components/xgs-select/xgsSelect";
import { XGSSelectOption } from "../../../../ui-components/xgs-select/xgsSelect";
import Button, { ButtonThemes } from "../../../../ui-components/button/button";
import { PickupReviewStatus } from "../../../../app/data/communications/models";
import { REVIEW_STATUS_LABELS } from "../constants";

const reviewStatusOptions: XGSSelectOption[] = [
  { value: "", label: "All review statuses" },
  ...([
    "REQUIRE_HUMAN_REVIEW",
    "APPROVED_BY_SYSTEM",
    "APPROVED_BY_HUMAN",
    "REJECTED_BY_HUMAN",
    "REJECTED_BY_SYSTEM",
  ] as PickupReviewStatus[]).map((s) => ({
    value: s,
    label: REVIEW_STATUS_LABELS[s],
  })),
];

const selectMenuStyles = {
  menuPortal: (base: CSSProperties) => ({ ...base, zIndex: 1100 }),
};

export interface InboxFiltersState {
  emailText: string;
  sender: string;
  bolNumber: string;
  poNumber: string;
  oneXgsPickupNumber: string;
  reviewStatus: PickupReviewStatus | "";
  hasPendingReview: boolean;
}

export interface InboxFiltersProps {
  filters: InboxFiltersState;
  onEmailTextChange: (value: string) => void;
  onSenderChange: (value: string) => void;
  onBolNumberChange: (value: string) => void;
  onPoNumberChange: (value: string) => void;
  onOneXgsPickupNumberChange: (value: string) => void;
  onReviewStatusChange: (value: PickupReviewStatus | "") => void;
  onClearFilters: () => void;
}

const InboxFilters: React.FC<InboxFiltersProps> = ({
  filters,
  onEmailTextChange,
  onSenderChange,
  onBolNumberChange,
  onPoNumberChange,
  onOneXgsPickupNumberChange,
  onReviewStatusChange,
  onClearFilters,
}) => (
  <div className="xgs-pickup-inbox__filters">
    <div className="xgs-pickup-inbox__filters-scroll">
      <LabeledTextInput
        label="Search:"
        labelMode={LabelModes.column}
        type="text"
        value={filters.emailText}
        onChange={(e) => onEmailTextChange(e.target.value)}
        placeholder="Search subject or preview"
        className="xgs-pickup-inbox__filter-field xgs-pickup-inbox__filter-search"
      />
      <LabeledTextInput
        label="Sender:"
        labelMode={LabelModes.column}
        type="text"
        value={filters.sender}
        onChange={(e) => onSenderChange(e.target.value)}
        placeholder="Filter by sender"
        className="xgs-pickup-inbox__filter-field"
      />
      <LabeledTextInput
        label="BOL:"
        labelMode={LabelModes.column}
        type="text"
        value={filters.bolNumber}
        onChange={(e) => onBolNumberChange(e.target.value)}
        placeholder="BOL number"
        className="xgs-pickup-inbox__filter-field"
      />
      <LabeledTextInput
        label="PO:"
        labelMode={LabelModes.column}
        type="text"
        value={filters.poNumber}
        onChange={(e) => onPoNumberChange(e.target.value)}
        placeholder="PO number"
        className="xgs-pickup-inbox__filter-field"
      />
      <LabeledTextInput
        label="Pickup #:"
        labelMode={LabelModes.column}
        type="text"
        value={filters.oneXgsPickupNumber}
        onChange={(e) => onOneXgsPickupNumberChange(e.target.value)}
        placeholder="OneXGS pickup number"
        className="xgs-pickup-inbox__filter-field"
      />
      <div className="xgs-pickup-inbox__filter-field xgs-pickup-inbox__filter-select">
        <span className="xgs-pickup-inbox__filter-label">Review status:</span>
        <XGSSelect
          value={
            reviewStatusOptions.find((o) => o.value === filters.reviewStatus) ??
            reviewStatusOptions[0]
          }
          options={reviewStatusOptions}
          onValueChange={(o) => onReviewStatusChange((o?.value as PickupReviewStatus) || "")}
          isClearable={false}
          menuPortalTarget={typeof document !== "undefined" ? document.body : undefined}
          menuPosition="fixed"
          styles={selectMenuStyles}
        />
      </div>
      {filters.hasPendingReview && (
        <span className="xgs-pickup-inbox__filter-badge">Pending review only</span>
      )}
      <Button
        theme={ButtonThemes.gray}
        type="button"
        onClick={onClearFilters}
        className="xgs-pickup-inbox__filter-clear"
      >
        Clear filters
      </Button>
    </div>
  </div>
);

export default InboxFilters;
